var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnionsBl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3020",
    "data-name": "Group 3020",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.677,
    height: 52.932,
    viewBox: "0 0 27.677 52.932",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3374",
    "data-name": "Path 3374",
    d: "M2238.724,129.766a2.167,2.167,0,0,1,2.1,1.638c1.4,5.561,4.181,8.544,6.633,11.176,2.624,2.816,5.1,5.475,5.1,10.384a9.362,9.362,0,0,1-1.133,4.453,11.4,11.4,0,0,1-3.02,3.553,16.3,16.3,0,0,1-19.37,0,11.372,11.372,0,0,1-3.021-3.553,9.362,9.362,0,0,1-1.134-4.453c0-4.909,2.478-7.569,5.1-10.384,2.452-2.632,5.23-5.614,6.634-11.175A2.166,2.166,0,0,1,2238.724,129.766Zm0,32.071a13.283,13.283,0,0,0,8.244-2.688,7.92,7.92,0,0,0,3.272-6.185c0-4-1.975-6.116-4.479-8.8a36.932,36.932,0,0,1-3.972-4.82,23.365,23.365,0,0,1-3.067-6.812,23.324,23.324,0,0,1-3.065,6.812,36.819,36.819,0,0,1-3.973,4.82c-2.5,2.685-4.479,4.806-4.479,8.8a7.923,7.923,0,0,0,3.273,6.184A13.286,13.286,0,0,0,2238.724,161.837Z",
    transform: "translate(-2224.885 -115.491)",
    fill: "#22294b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3375",
    "data-name": "Path 3375",
    d: "M2240.521,177.335a2.893,2.893,0,0,1-1.964-1.055c-.113-.109-.27-.26-.382-.35-.135.064-.33.185-.471.272a2.844,2.844,0,0,1-2.108.6,4.507,4.507,0,0,1-2.5-2.276l-.07-.108a1.16,1.16,0,1,1,1.943-1.269l.073.111a9.108,9.108,0,0,0,.7.976,1.584,1.584,0,0,0,.276.257c.13-.061.328-.183.47-.27a3.119,3.119,0,0,1,1.947-.643,3.053,3.053,0,0,1,1.734,1.027c.1.1.242.232.354.326.112-.093.25-.226.352-.326a3.073,3.073,0,0,1,1.736-1.026,3.126,3.126,0,0,1,1.949.643c.142.087.338.209.468.27a1.5,1.5,0,0,0,.277-.257,8.985,8.985,0,0,0,.7-.976l.071-.111a1.162,1.162,0,0,1,1.946,1.269l-.072.108a4.506,4.506,0,0,1-2.5,2.276,2.845,2.845,0,0,1-2.109-.6c-.141-.087-.337-.208-.471-.272-.113.089-.27.241-.384.35A2.891,2.891,0,0,1,2240.521,177.335Z",
    transform: "translate(-2226.684 -124.403)",
    fill: "#22294b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3378",
    "data-name": "Path 3378",
    d: "M2243.2,126.17a1.161,1.161,0,0,1-1.016-1.723,5.688,5.688,0,0,0,.563-2.635,27.273,27.273,0,0,0-.931-4.951,27.046,27.046,0,0,0-.932,4.951,5.688,5.688,0,0,0,.563,2.635,1.161,1.161,0,1,1-2.033,1.123,7.924,7.924,0,0,1-.852-3.758c0-2.46,1.922-8.93,2.141-9.66a1.162,1.162,0,0,1,2.225,0c.219.73,2.141,7.2,2.141,9.66a7.924,7.924,0,0,1-.852,3.758A1.163,1.163,0,0,1,2243.2,126.17Z",
    transform: "translate(-2227.978 -111.325)",
    fill: "#22294b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3379",
    "data-name": "Path 3379",
    d: "M2246.785,129.369a1.161,1.161,0,0,1-.821-1.982,5.756,5.756,0,0,0,1.271-2.38,21.157,21.157,0,0,0,.666-5.344,1.161,1.161,0,0,1-1.978-1.214c1.043-1.771,1.978-3.226,2.019-3.288a1.16,1.16,0,0,1,2.129.506c.025.237.6,5.846-.607,9.988a7.977,7.977,0,0,1-1.856,3.371A1.16,1.16,0,0,1,2246.785,129.369Z",
    transform: "translate(-2229.574 -112.072)",
    fill: "#22294b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3380",
    "data-name": "Path 3380",
    d: "M2237.4,129.369a1.157,1.157,0,0,1-.821-.341,7.972,7.972,0,0,1-1.857-3.371c-1.205-4.143-.633-9.751-.607-9.988a1.161,1.161,0,0,1,2.131-.507c.039.061.974,1.516,2.018,3.287a1.161,1.161,0,0,1-1.978,1.215,21.191,21.191,0,0,0,.666,5.343,5.751,5.751,0,0,0,1.27,2.379,1.161,1.161,0,0,1-.822,1.982Z",
    transform: "translate(-2226.936 -112.072)",
    fill: "#22294b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnionsBl);
export default __webpack_public_path__ + "static/media/Onions-bl.98e56239bde26a74bb4625ad4e22a3ba.svg";
export { ForwardRef as ReactComponent };